import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, ApplicationRef, NgModule, isDevMode } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './components/common/layout/footer/footer.component';
import { WhatWeDoComponent } from './components/common/utilities/what-we-do/what-we-do.component';
import { NavbarComponent } from './components/common/layout/navbar/navbar.component';
import { ProjectStartComponent } from './components/common/utilities/project-start/project-start.component';
import { HomeMainBannerComponent } from './components/pages/dynamic/home-main-banner/home-main-banner.component';
import { HomeFeaturedServicesComponent } from './components/pages/dynamic/home-featured-services/home-featured-services.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { LanguageService } from './services/language.service';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { ApiService } from './services/api/api.service';
import { SharedModule } from './shared/shared.module';
import { HomepageComponent } from './components/pages/dynamic/homepage/homepage.component';
import { HomeServicesComponent } from './components/pages/dynamic/home-services/home-services.component';
import { CookieConsentComponent } from './components/common/cookie-consent/cookie-consent.component';
import { ServiceWorkerModule } from '@angular/service-worker';

export function initializeApp(apiService: ApiService) {
  return () => apiService.loadTranslation();
}

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    WhatWeDoComponent,
    NavbarComponent,
    ProjectStartComponent,
    HomepageComponent,
    HomeMainBannerComponent,
    HomeFeaturedServicesComponent,
    HomeServicesComponent,
    CookieConsentComponent
  ], imports: [BrowserModule,
    AppRoutingModule,
    SharedModule,
    TranslateModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })], providers: [LanguageService,
      provideHttpClient(withInterceptorsFromDi()),
      ApiService,
      {
        provide: APP_INITIALIZER,
        useFactory: initializeApp,
        deps: [ApiService],
        multi: true, // Birden fazla APP_INITIALIZER olabilir
      }
    ]
})
export class AppModule {
  application: ApplicationRef | undefined;
  lang = '';
  constructor(
    private apiService: ApiService,
    private translate: TranslateService,
  ) {
  }

  async ngDoBootstrap(app: ApplicationRef) {
    await this.loadTranslation('tr');
    this.application = app;

    this.application.bootstrap(AppComponent);
  }

  async loadTranslation(lang: string) {
    await this.apiService.loadTranslation(lang);
    //this.languageService.changeLanguage(lang);
  }
}